import { BaseResource } from "./BaseResource";
import { apiResourceUrl } from "@ploy-lib/core";
export var ExtrasType;
(function (ExtrasType) {
    ExtrasType["NotSet"] = "NotSet";
    ExtrasType["Extras"] = "Extras";
    ExtrasType["Color"] = "Color";
})(ExtrasType || (ExtrasType = {}));
class CarObjectExtraResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.code = "";
    }
    pk() {
        return `${this.code}`;
    }
}
CarObjectExtraResource.urlRoot = apiResourceUrl("object-extra");
export { CarObjectExtraResource };
//# sourceMappingURL=CarObjectExtraResource.js.map